import { Link } from '@rocketlane/rocket-router';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { BodyShort01 } from 'components/styles';
import { RoutePaths } from 'constant';

const ForgotPasswordLink = styled(Link)`
  ${BodyShort01};
  white-space: nowrap;
`;

export const ForgotPassword = ({ isSamlMandate }) => {
  if (isSamlMandate) {
    return null;
  }

  return (
    <ForgotPasswordLink to={RoutePaths.forgotPassword}>
      <FormattedMessage id="forgot_password" />
    </ForgotPasswordLink>
  );
};
